import React from 'react';
import domainModel from 'domain-model';

import { Row, Col } from 'reactstrap';

import type { ProcurementArticle } from 'domain-model/types/pcs';
import type { ArticleReference } from 'domain-model/types/oms';
import Money from '../Money';
import WarehouseStatusIndicator from '../article/WarehouseStatusIndicator';
import ConnectedArticleQuantityInputJustButtons from '../inputs/ConnectedArticleQuantityInputJustButtons';
import DailyPriceIcon from '../article/DailyPriceIcon';
import PriceSpan from '../PriceSpan';
import GridCol from '../articleQuantityComponents/GridCol';

function ConnectedArticleQuantityInput({
  article,
  shadow,
  procurementArticle,
  isPurchasing,
}: {
  article: ArticleReference;
  shadow?: boolean;
  procurementArticle?: ProcurementArticle;
  isPurchasing?: boolean;
}): JSX.Element {
  const articleViewModel = domainModel.pricedArticle.getViewModel(article);

  const warehouseStatus =
    domainModel.pricedArticle.warehouseStatus(articleViewModel);

  const articleIsMissingPrice =
    articleViewModel.salesPrice === null ||
    articleViewModel.salesPrice === undefined;
  const colSize = articleViewModel.priceType && isPurchasing ? 3 : 4;
  return (
    <Row
      className={`connectedArticleQuantityInput align-items-center g-0 w-100
        ${shadow ? 'shadow' : ''}`}
    >
      <Col>
        <Row className="align-items-center g-0 bg-light text-sm">
          <GridCol
            className="displayOrderUnitSize-article"
            children={articleViewModel.displayOrderUnitSize}
            xs={colSize}
          />
          <GridCol
            className={`displayPriceComparison-article  ${
              articleViewModel.shouldHighlightPriceAsDiscounted
                ? 'text-danger'
                : ''
            }`}
            xs={colSize}
            children={
              articleViewModel.displayPriceComparison ? (
                <div>
                  <Money
                    value={articleViewModel.displayPriceComparison}
                    currency={articleViewModel.currency}
                  />
                  /{articleViewModel.displayPriceComparisonUnit}
                </div>
              ) : (
                <></>
              )
            }
          />
          <GridCol
            className="price-article"
            xs={colSize}
            children={
              <>
                <PriceSpan pricedArticle={articleViewModel} />
                <DailyPriceIcon article={articleViewModel} />
              </>
            }
          />
          {articleViewModel.priceType && isPurchasing && (
            <GridCol
              className="price-type text-danger"
              children={articleViewModel.getPriceType}
              xs={3}
            />
          )}
        </Row>
        {articleIsMissingPrice && (
          <Col className="text-center px-1 articleQuantityGrid missing-price text-sm">
            <strong>Pris saknas.</strong>{' '}
            <span className="text-xs">
              Kontakta {articleViewModel.myOrderFullfillmentCenter?.name} om du
              vill beställa denna vara
            </span>
          </Col>
        )}
        {!articleIsMissingPrice && (
          <>
            {!warehouseStatus.isPossibleToOrder && (
              <Col className="text-center mb-2 mt-1" sm={12}>
                {warehouseStatus.text || 'Tillfälligt slut'}
              </Col>
            )}
            {warehouseStatus.isPossibleToOrder && (
              <>
                <Col className="text-center just-buttons" xs={12} sm={12}>
                  <Row className="justify-content-end align-items-center g-0">
                    <GridCol
                      className="warehouseStatusIndicator"
                      xs={4}
                      children={
                        <WarehouseStatusIndicator article={article} size="xl" />
                      }
                    />

                    <Col xs={8}>
                      <ConnectedArticleQuantityInputJustButtons
                        article={article}
                        procurementArticle={procurementArticle}
                      />
                    </Col>
                  </Row>
                </Col>
              </>
            )}
          </>
        )}
      </Col>
    </Row>
  );
}

export default ConnectedArticleQuantityInput;
